<template>
  <div>
    <div v-for="accordion in accordions" :key="accordion.title">
      <BaseAccordian>
        <template v-slot:title>{{ accordion.title }}</template>

        <template v-slot:content>
          <div>{{ accordion.text }}</div>
        </template>
      </BaseAccordian>
    </div>
  </div>
</template>
<script>
import BaseAccordian from "@/components/BaseAccordion";

export default {
    name: 'Accordion',
  components: {
    BaseAccordian
  },
  data() {
    return {
      accordions: [
        {
          title: "What is Mealtrips?",
          text: "Mealtrips is an online food ordering and delivery service that connects its users to their favourite restaurants"
        },
        {
          title: "Can I order from different Restaurants at a time?",
          text: "Yes, you can order from as many restaurants at a time"
        },
        {
          title: "How do I make payment?",
          text: "All payments are done online, we don't accept pay on delivery"
        },
        {
          title: "How do I cancel my order?",
          text: "You can only cancel your order after a minute of ordering to avoid packaging and unpacking the food later"
        },
        {
          title: "How do I give complaints or feedback?",
          text: "You can give feedback or complaints through our website by filling the contact form or sending us a mail at mealtrips@gmail.com"
        },
        {
          title: "Is Mealtrips available in all states in Nigeria?",
          text: "We are currently available in Makurdi but we hope to be available nationwide soon"
        }
      ]
    };
  }
};
</script>

<style  scoped>
</style>